import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Header, Body, DashboardTemplate, TabFilters, Table, IconButton, Modal, Search, ContentLoader, TrashSolidIcon } from '../../_components'
import { store, simpleFetch, dateFormat, history } from '../../_helpers'
import { momentumUpdate, translateStatus } from './_functions'
import styles from './styles.module.scss'
import qs from 'qs'

export const MomentumsList = () => {
  const [ queryType, setQueryType ] = useState("momentum")

	const [ momentums, setMomentums ] = useState({
		requesting: true,
		list: []
	})

	const [ momentumsByCategory, setMomentumsByCategory ] = useState({
		All: [],
		Active: [],
		Scheduled: [],
		Paused: [],
		Draft: [],
		Deleted: [],
		Done: []
  })
  
  const [ activeTab, setActiveTab ] = useState("All")
  const [ modal, setModal ] = useState(false)
  const [ removing, setRemoving ] = useState({})

	const table = useRef(null)

	useEffect(() => {
    /* 
      Define a filter for which type 
      of momentums the list should have
    */
    let stringQueryType = "momentum"
      
    if ( history.location.pathname.indexOf('campaign') !== -1 ) {
      stringQueryType = "campaign"
      setQueryType("campaign")
    }
		
		getMomentums(stringQueryType)
	// eslint-disable-next-line no-use-before-define
	}, [])

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const getMomentums = useCallback(async (queryType) => {
		let domainUuid = JSON.parse(sessionStorage.getItem('selected_domain')).uuid
		if ( !domainUuid ) domainUuid = store.getState().changeDomainReducer.selectedDomain.domain_uuid

		// Reset data on reducer change
		setMomentums({
			requesting: true,
			list: []
		})

		setMomentumsByCategory({
			All: [],
			Active: [],
			Scheduled: [],
			Paused: [],
			Draft: [],
			Deleted: [],
			Done: []
		})

		// Get all momentums
		const req = await simpleFetch('GET', {}, {}, 'momentum', `momentum/list/${domainUuid}?type=${queryType}`)

		// Check if request has failed and the data returned is equal as 0
		if ( req.status !== 200 || req.data.length === 0 )
			return setMomentums({list: [], requesting: false})

		// Ordering data by status
		req.data.map(momentum => {
			if ( momentum.scheduled_at !== null && momentum.status === "Paused" ) {
				const arr = momentumsByCategory.Scheduled
				arr.push(momentum)

				return setMomentumsByCategory({
					...momentumsByCategory,
					Scheduled: arr.reverse()
				})
			}

			const arr = momentumsByCategory[momentum.status]
			if ( !arr ) return void 0
			arr.push(momentum)

			setMomentumsByCategory({
				...momentumsByCategory,
				[momentum.status]: arr.reverse()
			})
			return void 0
		})

		// Set all indexes into one array
		setMomentumsByCategory({
			...momentumsByCategory,
			All: req.data.reverse()
		})

		// When done, update the main state
		setMomentums({requesting: false, list: req.data})
	})

	const removeMomentumFromArray = (prevStatus, momentum) => {
    if ( activeTab === "All" ) return getMomentums()

		setMomentums({requesting: true, list: []})

		const mbc = momentumsByCategory
		const arr = momentumsByCategory[prevStatus].filter(obj => obj.uuid !== momentum.uuid)
		
		mbc[prevStatus] = arr
		mbc[momentum.status].push(momentum)

		const all = mbc.All.filter(obj => obj.uuid !== momentum.uuid)
		all.push(momentum)

		mbc.All = all

		setMomentumsByCategory(mbc)
		setMomentums({requesting: false, list: mbc[prevStatus]})
	}

	const handleChange = ({currentTarget, target}) => {
		const { name } = target

		currentTarget.parentNode
			.querySelector('[data-active="true"]')
			.removeAttribute('data-active')
		
    target.setAttribute('data-active', 'true')
    setActiveTab(name)

		setMomentums({...momentums, list: momentumsByCategory[name]})
	}

	const handleClick = async ({target}) => {
		const momentum = target.parentNode.parentNode.getAttribute('data-momentum')

		const types = {
			"start": () => { momentumUpdate(momentum, "Active", removeMomentumFromArray) },
			"pause": () => { momentumUpdate(momentum, "Paused", removeMomentumFromArray) },
      "delete": () => { momentumUpdate(momentum, "Deleted", removeMomentumFromArray) }
		}

		const selectedType = types[target.name]
		if ( !selectedType ) return

		selectedType()
	}

	return (<>
		<DashboardTemplate>
			<Header
				title={queryType === "campaign" ? "Campanhas" : "Momentums"}
				link={{
					label: (queryType === "campaign") ? "Campanha" : "Momentum",
					path: (queryType === "campaign") ? '/v2/campaign/create' : '/v2/momentum/create'
				}}
			/>
			<Body>
				<div ref={table}>
					<div className="d-flex">
						<TabFilters
							momentumsByCategory={momentumsByCategory}
							onClick={handleChange}
						/>
						
						{
							table.current ?
								<Search
									type="text"
									placeholder="Digite sua busca"
									parent={table.current}
									childs="tr[data-own='tbody']"
								/>
							: null
						}
					</div>

					<Table headers={[ "#", "Título", "Status", "Canal", "Agendado para", "Criado em", "Atualizado em", "Ações" ]} >
						{
							!momentums.requesting && momentums.list ?
								momentums.list.length !== 0 ?
									momentums.list.map((m, i) => {
										return <tr key={m.uuid} data-own="tbody">
											<td>{i}</td>
											<td title={m.momentum_title} style={ {
												maxWidth: '13vw',
												whiteSpace: 'nowrap',
												overflow: 'hidden',
												textOverflow: 'ellipsis'
											} }>{m.momentum_title}</td>
											<td>{translateStatus(m.status, m.scheduled_at)}</td>
											<td>{m.channels?.channel_type.split('_')[0]}</td>
											<td style={{width: "185px", textAlign: "center"}}>{dateFormat(m.scheduled_at)}</td>
											<td style={{width: "185px", textAlign: "center"}}>{dateFormat(m.created_at)}</td>
											<td style={{width: "185px", textAlign: "center"}}>{dateFormat(m.updated_at)}</td>
											<td>
												<div className="d-flex justify-content-center" data-momentum={JSON.stringify(m)}>
													{
														m.status === 'Draft' ? null :
														m.status === "Active" ?
															<IconButton
																icon="PauseSolidRounded"
																label="Pausar"
																name="pause"
																onClick={handleClick}
															/>
														:	<IconButton
																icon="StartSolidRounded"
																label="Iniciar"
																name="start"
																onClick={handleClick}
															/>
													}

													<IconButton
														icon="EyeSolid"
														label="Visualizar"
														name="view"
														onClick={() => history.push(`/v2/${queryType}/create?ref=${m.uuid}&viewonly`)}
													/>

													<IconButton
														icon="PencilSolid"
														label="Editar"
														name="edit"
														path={`/v2/momentum/create?${ qs.stringify( m, { skipNulls: true } ) }`}
														onClick={handleClick}
													/>

													<IconButton
														icon="TrashSolid"
														label="Remover"
														name="delete"
														onClick={() => {
                              setModal(true)
                              setRemoving({momentum: JSON.stringify(m), title: m.momentum_title})
                            }}
													/>
												</div>
											</td>
										</tr>
									})
								: null
							: <tr data-own="tbody">
									<td><ContentLoader /></td>
									<td><ContentLoader /></td>
									<td><ContentLoader /></td>
									<td><ContentLoader /></td>
									<td style={{width: "185px", textAlign: "center"}}><ContentLoader /></td>
									<td style={{width: "185px", textAlign: "center"}}><ContentLoader /></td>
									<td style={{width: "185px", textAlign: "center"}}><ContentLoader /></td>
									<td><ContentLoader /></td>
								</tr>
						}
					</Table>
				</div>
			</Body>
		</DashboardTemplate>

    <Modal
      active={{
        status: modal, onChange: setModal
      }}
      width="398px"
    >
      <div className={styles['modal__confirmation']}>
        <div className="flex">
          <div className="flex__group mgright-25">
            <TrashSolidIcon />
          </div>
          <div className="flex__group">
            <p>Deseja confirmar a exclusão do momentum <strong>"{removing.title && removing.title}"</strong>?</p>
          </div>
        </div>
        <div className="flex flex--center mgtop-25">
          <button
            type="button"
            className="button button--uppercase button--white-outlined"
            onClick={() => {
              setRemoving({})
              setModal(false)
            }}
            style={{marginRight: "8px"}}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="button button--uppercase button--blue"
            onClick={() => {
              momentumUpdate(removing.momentum, "Deleted", removeMomentumFromArray)
              setModal(false)
              setRemoving({})
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </Modal>
	</>)
}